import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { INK, FG_3, LINE, PURPLE, CYAN, BLUE, YELLOW, FONTS } from './theme.js';
import { POK_FACTS, POK_INSTITUTIONS_LABEL } from '../../constants.js';

const SUCCESS_DOT = '#58E07E';

const DEFAULT_STATS = [
    { value: '1.5', suffix: 'M+', dot: SUCCESS_DOT, tKey: 'mc.stats.1' },
    { prefix: '+', value: POK_INSTITUTIONS_LABEL, dot: CYAN, tKey: 'mc.stats.2' },
    { value: String(POK_FACTS.countries), dot: BLUE, tKey: 'mc.stats.3' },
    { value: 'Top 100', dot: YELLOW, tKey: 'mc.stats.4' },
];

export function StatsBar({ stats: statsProp }) {
    const { t } = useTranslation();
    const stats = statsProp ?? DEFAULT_STATS.map(({ tKey, ...rest }) => ({ ...rest, label: t(tKey) }));

    return (
        <Box component="section" sx={{ background: '#fff', borderBottom: `1px solid ${LINE}` }}>
            <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6.5 } }}>
                <Grid container>
                    {stats.map((s, i) => (
                        <Grid key={i} size={{ xs: 6, md: 3 }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    px: 3,
                                    py: { xs: 2, md: 0 },
                                    borderLeft: { xs: 'none', md: i === 0 ? 'none' : '1px solid rgba(26,23,38,0.1)' },
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.9 }}>
                                    <Box
                                        sx={{ width: 7, height: 7, borderRadius: '50%', background: s.dot ?? PURPLE }}
                                    />
                                    <Typography
                                        sx={{
                                            fontFamily: FONTS.mono,
                                            fontSize: '0.66rem',
                                            fontWeight: 500,
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                            color: FG_3,
                                        }}
                                    >
                                        {s.label}
                                    </Typography>
                                </Box>
                                <Typography
                                    component="div"
                                    sx={{
                                        fontSize: { xs: '2.25rem', md: '3rem' },
                                        fontWeight: 700,
                                        letterSpacing: '-0.035em',
                                        color: INK,
                                        lineHeight: 0.92,
                                        fontVariantNumeric: 'tabular-nums',
                                    }}
                                >
                                    {s.prefix && (
                                        <Box
                                            component="span"
                                            sx={{ fontSize: '0.6em', fontWeight: 600, color: PURPLE, mr: 0.4 }}
                                        >
                                            {s.prefix}
                                        </Box>
                                    )}
                                    {s.value ?? s.number}
                                    {s.suffix && (
                                        <Box
                                            component="span"
                                            sx={{ fontSize: '0.6em', fontWeight: 600, color: PURPLE, ml: 0.4 }}
                                        >
                                            {s.suffix}
                                        </Box>
                                    )}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
